import styled from '@emotion/styled';

import {
  breakpoints,
  colors,
  fontSize,
  gradients,
} from '@datacamp/waffles-tokens';

import ImageTech from 'images/header-bg.jpg';

export const ButtonWrapper = styled.div`
  padding-top: 16px;
  text-align: center;
`;

export const Container = styled.section`
  margin: 0 auto;
  max-width: 1170px;
  position: relative;

  @media screen and (min-width: ${breakpoints.sm}) {
    padding: 0 16px 0;
  }
`;

export const Grid = styled.div`
  margin: 0 auto;

  @media screen and (min-width: ${breakpoints.sm}) {
    display: flex;
    flex-wrap: wrap;

    .item {
      display: flex;
      width: calc(50% - 32px);
    }
  }

  @media screen and (min-width: ${breakpoints.md}) {
    .item {
      width: calc(33.33333% - 32px);
    }
  }

  @media screen and (min-width: ${breakpoints.lg}) {
    margin: 0 -16px;
  }
`;

export const Header = styled.header`
  background-color: #1e2c43;
  background-image: url(${ImageTech});
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 156px; /* DS violation to match Zeplin */
  text-align: center;

  @media screen and (min-width: ${breakpoints.md}) {
    padding-bottom: 220px; /* DS violation to match Zeplin */
  }
`;

export const Headline = styled.h1`
  color: ${colors.white};
  display: inline-block;
  font-size: 50px; /* DS violation to match zeplin */
  line-height: 1;
  margin: 96px 0 0 0;
  position: relative;

  span {
    position: relative;
    z-index: 1;
  }

  &::before {
    background: ${gradients.puertoricoDeyork};
    content: '';
    height: 80%;
    left: -8px;
    position: absolute;
    right: -8px;
    top: 12px;
  }
`;

export const Byline = styled.p`
  color: ${colors.white};
  font-size: ${fontSize.h5};
`;
